window.theme = window.theme || {};

theme.cart = (function(){

    if (theme.storeDomain == 'www.wit-fitness.com'){
        var insuranceVariantId = 1369056411668;
    }else if (theme.storeDomain == 'us.wit-fitness.com'){
        var insuranceVariantId = 14141585719363;
    }

    var selectors = {
        addInsurance: '[js-cart="addInsurance"]'
    }

    function _cacheSelectors(){
        $addInsurance = $(selectors.addInsurance);
        _initEvents();
        _checkInsuranceInCart();
    }

    function _initEvents(){
        $addInsurance.on('change', function(){
            _disableCheckbox(true);
            if (_insuranceISChecked()){
                _addInsuranceToCart()
            }else{
                _removeInsuranceToCart()
            }
        });
    }

    function _insuranceISChecked(){
        return $addInsurance.is(':checked');
    }

    function _removeInsuranceToCart(){
        if (theme.storeDomain == 'www.wit-fitness.com'){
            var remove = {1369056411668: 0};
        }else if (theme.storeDomain == 'us.wit-fitness.com'){
            var remove = {14141585719363: 0};
        }
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: {
                updates: remove
            },
            success: function() {
                location.reload();
            },
            error: function() {
                
            }
        });
    }

    function _addInsuranceToCart(){
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: 1,
                id: insuranceVariantId
            },
            success: function() {
                location.reload();
            },
            error: function() {
                
            }
        });
    }

    function _disableCheckbox(disabled){
        $addInsurance.prop('disabled', disabled);
    }

    function _checkCheckbox(checked){
        $addInsurance.attr('checked', checked);
    }

    function _checkInsuranceInCart(){
        _disableCheckbox(true);
        $.getJSON('/cart.js', function(data){
            for (i = 0; i < data.items.length; i++) {
                if (data.items[i].variant_id == insuranceVariantId ){
                    _checkCheckbox(true)
                }
            }
        });
        _disableCheckbox(false);
    }

    function _init(){
        _cacheSelectors();
    }

    return {
        init: _init
    }
})();


$(function() {
    theme.cart.init();
});